export type SectionFourActionKey =
  | "view"
  | "sendToSign"
  | "rejectSign"
  | "rollback"
  | "edit"
  | "versions"
  | "delete";

const editOnlyActions: SectionFourActionKey[] = [
  "sendToSign",
  "delete",
  "edit",
  "rejectSign",
  "rollback",
];

export const getSectionFourActions = (
  status?: string,
  hasEditPermission = false,
): SectionFourActionKey[] => {
  let actions: SectionFourActionKey[];

  switch (status) {
    case "NEW":
      actions = ["view", "sendToSign", "edit", "delete"];
      break;
    case "AWAITING_SIGNATURE":
      actions = ["view", "rejectSign"];
      break;
    case "REJECTED":
      actions = ["view", "rollback"];
      break;
    case "SIGNED":
      actions = ["view", "versions", "edit"];
      break;
    case "SENT_TO_GSN":
      actions = ["view", "versions"];
      break;
    default:
      actions = ["view"];
  }

  if (!hasEditPermission) {
    return actions.filter((action) => !editOnlyActions.includes(action));
  }

  return actions;
};


